import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-470268e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to switch to this user? ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " You will be signed out of your account and signed in as this user. Once signed in, they will not be able to switch back to your account. ", -1))

import { computed, ref } from 'vue'
import { useTokenManager } from '@/auth/TokenManager'
import { useUserStore } from '@/gp/UserStore'
import { reloadApp } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import UserItem from './UserItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSwitchModal',
  setup(__props, { expose: __expose }) {

const userIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const tokenManager = useTokenManager()

const userRef = computed(() => userStore.getAsyncUser(userIdRef.value)?.data)

__expose({
  open,
})

function open(userId: string) {
  userIdRef.value = userId
  modalRef.value?.open()
}

async function switchUser() {
  await tokenManager.impersonateAsync(userIdRef.value!)
  reloadApp()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: switchUser
  }, {
    title: _withCtx(() => [
      _createTextVNode("Switch user")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Switch to user")
    ]),
    busyText: _withCtx(() => [
      _createTextVNode("Switching...")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UserItem, { "user-id": userIdRef.value }, null, 8, ["user-id"]),
      _hoisted_2
    ]),
    _: 1
  }, 512))
}
}

})